import {timetable_editTimetableDetailMeetingUrl_Api} from 'apis'
import {Button, Input} from 'antd'
import DrawDialog from 'components/drawer/dialog/DrawDialog'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useState} from 'react'
import {BsCameraVideo} from 'react-icons/bs'
import {urlFormat} from '../../../components/form/ValidateForm'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify} from 'views/AppLocals/factory/createNotification'

// DrawDialog sửa nhanh link Meet/Zoom của 1 buổi học cụ thể, mirror ĐÚNG SessionNotesDrawer.js -
// chỉ khác field đơn (URL, có validate) thay vì text tự do. meeting_url là field MỚI trên
// TimetableDetail (092_add_meeting_url_to_timetable_details.sql) - CHỦ Ý độc lập từng buổi, không
// bị TimetableController::update() ép đồng bộ theo Timetable cha như location_address, nên đây là
// nơi DUY NHẤT sửa được field này ngoài form Lịch trình đầy đủ. Không có online/offline flag riêng
// cho buổi học - buổi CÓ meeting_url (không rỗng) tức là có phần online, tự động hiện nút "Vào
// phòng học online" ở SessionCard (MyClassSessionsPanel.js), không cần đồng bộ 2 field dễ lệch nhau.
const SessionMeetingLinkBody = ({session, onSaved, onClose}) => {
    const t = useTranslate()
    const [url, setUrl] = useState(session?.meeting_url || '')

    useEffect(() => {
        setUrl(session?.meeting_url || '')
    }, [session])

    const error = url ? urlFormat(t)(url) : null

    const {handleAsyncAction: onSave, isLoading} = useAsyncAction({
        apiInfo: timetable_editTimetableDetailMeetingUrl_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            if (onSaved) onSaved()
            onClose()
        },
    })

    return (
        <div className="flex flex-col gap-3">
            <Input
                placeholder={t('session meeting link placeholder')}
                value={url}
                onChange={(e) => setUrl(e.target.value)}
            />
            {error && <span className="text-xs text-rose-600">{error}</span>}
            <div className="flex justify-end gap-2 pt-2 border-t border-color-50">
                <Button onClick={onClose}>{t('cancel')}</Button>
                <Button
                    type="primary"
                    loading={isLoading}
                    disabled={!!error}
                    onClick={() => onSave({meeting_url: url.trim() || null}, {id: session?.id})}>
                    {t('save')}
                </Button>
            </div>
        </div>
    )
}

// trigger - override nút mở drawer (mặc định nút text+icon như cũ) - xem comment tương ứng ở
// SessionMaterialsDrawer.js.
export const SessionMeetingLinkDrawer = ({session, onRefresh, trigger}) => {
    const t = useTranslate()
    return (
        <DrawDialog
            title={t('manage session meeting link')}
            width={480}
            component={
                trigger || (
                    <button
                        type="button"
                        title={t('manage session meeting link')}
                        className="flex items-center gap-1 text-2xs font-medium text-color-400 hover:text-indigo-600 whitespace-no-wrap">
                        <BsCameraVideo size={11}/>
                        {t('session meeting link label')}
                    </button>
                )
            }>
            {(isToggle, toggle) => isToggle && (
                <SessionMeetingLinkBody session={session} onSaved={onRefresh} onClose={() => toggle(false)}/>
            )}
        </DrawDialog>
    )
}

export default SessionMeetingLinkDrawer
